module.exports = __webpack_public_path__ + "static/suitcase-57214008be3b4acd595cf3b2c396bac5.svg";